"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroller = void 0;
var meta_1 = require("./meta");
var message_type_1 = require("../bridge/message-type");
var Scroller = /** @class */ (function () {
    function Scroller() {
    }
    Scroller.scrollClientSiteToTopIfNeeded = function () {
        parent.postMessage({
            type: message_type_1.MessageType.ScrollToTopIfNeeded,
            offset: meta_1.Meta.scrollTopOffset,
        }, meta_1.Meta.host);
    };
    return Scroller;
}());
exports.Scroller = Scroller;
